var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19V9.58976C21 8.89097 20.6353 8.24285 20.038 7.88019L13.038 3.63019C12.4002 3.24295 11.5998 3.24295 10.962 3.63019L3.96204 7.88019C3.36472 8.24285 3 8.89097 3 9.58976V19C3 19.5523 3.44771 20 4 20H8.3C8.85228 20 9.3 19.5523 9.3 19V16.1676C9.3 15.6153 9.74772 15.1676 10.3 15.1676H13.7C14.2523 15.1676 14.7 15.6153 14.7 16.1676V19C14.7 19.5523 15.1477 20 15.7 20H20C20.5523 20 21 19.5523 21 19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3ffb8601f399235cbff0bcc90c345613.svg";
export { ForwardRef as ReactComponent };